import React, { Component, useEffect, useState } from "react";
import {
	Container,
	Card,
	CardHeader,
	Button,
	CardBody,
	CardFooter,
	FormGroup,
	Label,
	Row,
	Table,
	Col,
	Modal,
	ModalHeader,
	ModalBody,
	ModalFooter,
} from "reactstrap";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Select from "react-select";
import moment from "moment";
import Swal from "sweetalert2";
import DefaultImg from "../../../assets/images/product/Default_img.jpg";

import {
	getMiniLocations,
	getMiniSubLocations,
	getMiniSubOrderLocations,
	getMiniDepartment,
	getUserDepartment,
	getMiniBasicUnits,
} from "../../../store/Mini/actions";

import {
	InputChangeValue,
	SelecteChangeValue,
	MRInputChangeValue,
	MRSelecteChangeValue,
	SIInputChangeValue,
	SISelecteChangeValue,
	getAllProducts,
	SelectedProducts,
	removeSelectProducts,
	model_open,
	model_close,
	addMaterialRequest,
	getReqestRowDetails,
	clearData,
	UpdateMRImage,
} from "../../../store/MaterialRequest/actions";
import LoadingModel from "../../LoadingModel";

function PdfViewer({ url }) {
	const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

	useEffect(() => {
		const fetchPdf = async () => {
			try {
				let finalUrl = url;

				if (
					window.location.hostname === "localhost" &&
					url.startsWith("http://vendpin.dev.absol.in")
				) {
					finalUrl = url.replace("http://vendpin.dev.absol.in", "");
				}

				const response = await fetch(finalUrl);
				console.log(finalUrl, "finalurl");
				if (!response.ok)
					throw new Error("Network response was not ok");

				const blob = await response.blob();
				const blobUrl = URL.createObjectURL(blob);
				setPdfBlobUrl(blobUrl);
			} catch (err) {
				console.error("Failed to load PDF", err);
			}
		};
		fetchPdf();
	}, [url]);

	if (!pdfBlobUrl)
		return <p style={{ padding: "10px" }}>Loading PDF preview...</p>;

	return (
		<iframe
			src={pdfBlobUrl}
			width="100%"
			height="600px"
			style={{ border: "none" }}
			title="PDF Document"
		/>
	);
}

class NewMaterialRequest extends Component {
	constructor(props) {
		super(props);
		this.state = {
			activeTab: 1,
			isAlertOpen: false,
			location_id: 0,
			orderlocation_id: 0,
			location_name: "Select Location",
			orderlocationLabel: "select orderlocationLabel",
			department_id: 0,
			department_name: "Select Department",
			reqStateRowData: {},
			request_items: [],
			reqdate: "",
			selectedOrderLocation: null,
			showImageModal: false,
		};

		this.removeCartItem.bind(this);

		this.ChangeHandeler = this.ChangeHandeler.bind(this);
		this.MRChangeHandeler = this.MRChangeHandeler.bind(this);
		this.SItemChangeHandeler = this.SItemChangeHandeler.bind(this);
		this.handleValidSubmit = this.handleValidSubmit.bind(this);
	}

	componentDidMount() {
		this.props.getMiniLocations();
		this.props.getMiniDepartment();
		this.props.getUserDepartment();
		this.props.getMiniBasicUnits();

		localStorage.setItem("itemsArray", null);
		if (this.props.match.params.id !== "0") {
			this.props.getReqestRowDetails(this.props.match.params.id);
		} else {
			this.props.clearData();
		}
	}

	ChangeHandeler(e) {
		this.props.InputChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}
	MRChangeHandeler(e) {
		this.props.MRInputChangeValue({
			key: e.target.name,
			value: e.target.value,
		});
	}
	SItemChangeHandeler(e, item) {
		this.props.SIInputChangeValue({
			key: e.target.name,
			value: e.target.value,
			item,
		});
	}
	removeCartItem = (id) => {
		this.props.removeSelectProducts(id);
	};
	handleValidSubmit() {
		var that = this;
		var data = this.props.mrRowData;

		var mritems = [];
		var departmentids = this.props.selectedItems.map((item) => {
			return item.department.id;
		});
		this.props.selectedItems.map((item) => {
			var Pitem = {
				dodelete: item.dodelete ? true : false,
				id: item.id,
				qty: item.qty,
				unit_id: item.unit.id,
				department_id: item.department.id,
				date: moment(item.date, "DD-MM-YYYY").format("YYYY-MM-DD"),
				make: item.make,
				description: item.description,
				item_info: item.item_info,
				product_id: item.product.id,
			};
			mritems.push(Pitem);
			return 0;
		});
		if (this.props.selectedItems.length !== 0) {
			if (data.location_id != null) {
				this.props.addMaterialRequest(
					{
						date:
							data?.date == null
								? moment(new Date()).format("YYYY-MM-DD")
								: moment(data.date).format("YYYY-MM-DD"),
						description: data.description,
						location_id: data?.location_id,
						sublocation_id:
							data?.sublocation_id == null
								? this.props.sublocationslist[0]?.id
								: data?.sublocation_id,
						orderlocation_id:
							data?.orderlocation_id == null
								? this.props.suborderlocationslist[0]?.id
								: data?.orderlocation_id,
						department_ids: departmentids,
						userdepartment_id:
							data?.userdepartment_id == null
								? this.props.userDeparment[0]?.id
								: data?.userdepartment_id,
						mritems: mritems,
					},
					this.props.match.params.id,
					this.props.history,
					function (sucess, MRData) {
						if (sucess) {
							try {
								that.MRItemImageUpdate(MRData);
							} catch (error) {}
						} else {
							Swal.fire({
								icon: "error",
								title: "Image Upload Failed",
							});
						}
					}
				);
			} else {
				Swal.fire({
					icon: "error",
					text: "Select Location",
				});
			}
		} else {
			Swal.fire({
				icon: "error",
				text: "Select Items",
			});
		}
	}
	MRItemImageUpdate(MRData) {
		MRData.mritems.forEach((item) => {
			this.props.MRItemImage.filter(
				(omritem) => omritem.Product_id === item.product.id
			).map((omritem) => {
				for (var i = 0; i < omritem.ItemImages.length; i++) {
					var img = omritem.ItemImages[i];
					this.props.UpdateMRImage({
						materialrequest_id: MRData.id,
						mritem_id: item.id,
						image: img,
					});
				}
				return 0;
			});
		});

		// MRData.mritems.map((item) => {
		//   item.
		// });
	}

	render() {
		const {
			match: { params },
		} = this.props;

		return (
			<React.Fragment>
				<div className="page-content">
					<Container fluid>
						{this.props.loading && (
							<LoadingModel OpenModel={this.props.loading} />
						)}
						<AvForm
							className="needs-validation"
							onValidSubmit={this.handleValidSubmit}>
							<Row>
								<Col md={12}>
									<Card>
										<CardHeader className="bg-transparent border-bottom ">
											<Link
												to="/mrdashboard1"
												className="action-icon text-primary mr-2">
												<i className="mdi mdi-arrow-left-bold-circle-outline font-size-20"></i>
											</Link>
											<h5 className="card-title-18 pt-2 d-inline-block">
												New Material Request
											</h5>
										</CardHeader>
										<CardBody className="pt-1">
											<Row className="p-1">
												<Col
													md={12}
													xl={4}
													className="p-1">
													<Card className="p-1">
														<CardBody className="pt-1">
															<Row className="p-0">
																<Col
																	md={12}
																	className="p-1">
																	<h3 className="card-title-15">
																		Request
																		Details
																	</h3>
																</Col>
															</Row>
															<Row className="p-0">
																<Col
																	md="12"
																	className="p-1 m-0">
																	<FormGroup className="select2-container">
																		<Label>
																			Location
																		</Label>
																		<Select
																			id="location_id_select"
																			name="location_id_select"
																			classNamePrefix="select2-selection"
																			options={this.props.locationslist.map(
																				(
																					item
																				) => ({
																					label: item.name,
																					value: item.id,
																				})
																			)}
																			value={
																				this
																					.props
																					.mrRowData
																					?.location_id
																					? {
																							label: this
																								.props
																								.mrRowData
																								.locationLabel,
																							value: this
																								.props
																								.mrRowData
																								.location_id,
																					  }
																					: null
																			}
																			onChange={(
																				e
																			) => {
																				// load sublocations
																				this.props.getMiniSubLocations(
																					e.value
																				);

																				// update redux state
																				this.props.MRSelecteChangeValue(
																					{
																						key: "locationLabel",
																						label: e.label,
																						key2: "location_id",
																						value: e.value,
																					}
																				);

																				// reset dependent dropdowns
																				this.props.MRSelecteChangeValue(
																					{
																						key: "sublocationLabel",
																						label: null,
																						key2: "sublocation_id",
																						value: null,
																					}
																				);
																				this.props.MRSelecteChangeValue(
																					{
																						key: "orderlocationLabel",
																						label: null,
																						key2: "orderlocation_id",
																						value: null,
																					}
																				);
																			}}
																		/>
																	</FormGroup>
																</Col>

																<Col
																	md="12"
																	className="p-1 m-0">
																	<FormGroup className="select2-container">
																		<Label>
																			Sub
																			Location
																		</Label>
																		<Select
																			id="sublocation_id_select"
																			name="sublocation_id_select"
																			classNamePrefix="select2-selection"
																			isDisabled={
																				!this
																					.props
																					.mrRowData
																					?.location_id
																			}
																			options={this.props.sublocationslist.map(
																				(
																					item
																				) => ({
																					label: item.name,
																					value: item.id,
																				})
																			)}
																			value={
																				this
																					.props
																					.mrRowData
																					?.sublocation_id
																					? {
																							label: this
																								.props
																								.mrRowData
																								.sublocationLabel,
																							value: this
																								.props
																								.mrRowData
																								.sublocation_id,
																					  }
																					: null
																			}
																			onChange={(
																				e
																			) => {
																				const locationId =
																					this
																						.props
																						.mrRowData
																						?.location_id;

																				// load sub order locations using both ids
																				this.props.getMiniSubOrderLocations(
																					locationId,
																					e.value
																				);

																				this.props.MRSelecteChangeValue(
																					{
																						key: "sublocationLabel",
																						label: e.label,
																						key2: "sublocation_id",
																						value: e.value,
																					}
																				);

																				// reset orderlocation
																				this.props.MRSelecteChangeValue(
																					{
																						key: "orderlocationLabel",
																						label: null,
																						key2: "orderlocation_id",
																						value: null,
																					}
																				);
																			}}
																		/>
																	</FormGroup>
																</Col>

																<Col
																	md="12"
																	className="p-1 m-0">
																	<FormGroup className="select2-container">
																		<Label>
																			Order
																			Location
																		</Label>
																		<div className="d-flex align-items-center">
																			{/* Dropdown */}
																			<div
																				style={{
																					flex: 1,
																				}}>
																				<Select
																					id="orderlocation_id_select"
																					name="orderlocation_id_select"
																					classNamePrefix="select2-selection"
																					isDisabled={
																						!this
																							.props
																							.mrRowData
																							?.sublocation_id
																					}
																					options={this.props.suborderlocationslist.map(
																						(
																							item
																						) => ({
																							label: item.name,
																							value: item.id,
																							image: item.image, // use full URL
																						})
																					)}
																					value={
																						this
																							.props
																							.mrRowData
																							?.orderlocation_id
																							? {
																									label: this
																										.props
																										.mrRowData
																										.orderlocationLabel,
																									value: this
																										.props
																										.mrRowData
																										.orderlocation_id,
																							  }
																							: null
																					}
																					onChange={(
																						e
																					) => {
																						// update Redux
																						this.props.MRSelecteChangeValue(
																							{
																								key: "orderlocationLabel",
																								label: e.label,
																								key2: "orderlocation_id",
																								value: e.value,
																							}
																						);

																						// store selected location in local state
																						const selected =
																							this.props.suborderlocationslist.find(
																								(
																									item
																								) =>
																									item.id ===
																									e.value
																							);
																						this.setState(
																							{
																								selectedOrderLocation:
																									selected,
																							}
																						);
																					}}
																				/>
																			</div>

																			<Button
																				color="info"
																				size="sm"
																				className="ml-2"
																				style={{
																					whiteSpace:
																						"nowrap",
																				}}
																				disabled={
																					!this
																						.state
																						.selectedOrderLocation
																						?.image
																				}
																				onClick={() =>
																					this.setState(
																						{
																							showImageModal: true,
																						}
																					)
																				}>
																				View
																			</Button>

																			{/* {this
																				.state
																				.showPdfCard && (
																				<Button
																					color="secondary"
																					size="sm"
																					className="ml-2"
																					onClick={() =>
																						this.setState(
																							{
																								showPdfCard: false,
																							}
																						)
																					}>
																					Hide
																				</Button>
																			)} */}

																			{/* {this
																				.state
																				.selectedOrderLocation
																				?.image && (
																				<Row className="mt-3">
																					<Col
																						md={
																							12
																						}>
																						<Card>
																							<CardHeader>
																								<h5>
																									Order
																									Location
																									Document:{" "}
																									{
																										this
																											.state
																											.selectedOrderLocation
																											.name
																									}
																								</h5>
																							</CardHeader>
																							<CardBody className="p-0">
																								{this.state.selectedOrderLocation.image.includes(
																									".pdf"
																								) ? (
																									<object
																										data={
																											this
																												.state
																												.selectedOrderLocation
																												.image
																										}
																										type="application/pdf"
																										width="100%"
																										height="600px"
																										style={{
																											border: "none",
																										}}>
																										<p>
																											PDF
																											cannot
																											be
																											displayed.{" "}
																											<a
																												href={
																													this
																														.state
																														.selectedOrderLocation
																														.image
																												}>
																												Download
																												instead
																											</a>

																											.
																										</p>
																									</object>
																								) : (
																									<img
																										src={
																											this
																												.state
																												.selectedOrderLocation
																												.image
																										}
																										alt="Order Location"
																										style={{
																											maxWidth:
																												"100%",
																											height: "auto",
																											borderRadius:
																												"8px",
																										}}
																									/>
																								)}
																							</CardBody>
																						</Card>
																					</Col>
																				</Row>
																			)} */}
																		</div>
																	</FormGroup>
																</Col>

																<Col
																	md="12"
																	className="p-1 m-0">
																	<FormGroup className="select2-container">
																		<Label>
																			User
																			Department
																		</Label>
																		<Select
																			id="Userdepartment_id"
																			name="Userdepartment_id"
																			classNamePrefix="select2-selection"
																			options={this.props.userDeparment.map(
																				(
																					item,
																					index
																				) => ({
																					label: item.name,
																					value: item.id,
																				})
																			)}
																			value={{
																				label:
																					this
																						.props
																						.mrRowData
																						?.userdepartmentLabel ==
																					null
																						? this
																								.props
																								.userDeparment[0]
																								?.name
																						: this
																								.props
																								.mrRowData
																								?.userdepartmentLabel,
																				value:
																					this
																						.props
																						.mrRowData
																						?.userdepartment_id ==
																					null
																						? this
																								.props
																								.userDeparment[0]
																								?.id
																						: this
																								.props
																								.mrRowData
																								?.userdepartment_id,
																			}}
																			onChange={(
																				e
																			) => {
																				this.props.MRSelecteChangeValue(
																					{
																						key: "userdepartmentLabel",
																						label: e.label,
																						key2: "userdepartment_id",
																						value: e.value,
																					}
																				);
																			}}
																		/>
																	</FormGroup>
																</Col>

																<Col
																	md="12"
																	className="p-1">
																	<FormGroup
																		style={{
																			marginBottom:
																				"0px",
																		}}>
																		<Label
																			htmlFor="validationDate"
																			className="mb-0 col-form-label">
																			Required
																			Date
																			:
																		</Label>

																		<AvField
																			name="date"
																			placeholder="Date"
																			type="date"
																			min={moment(
																				new Date()
																			).format(
																				"YYYY-MM-DD"
																			)}
																			errorMessage="Select Required Date "
																			style={{
																				marginBottom:
																					"0px",
																			}}
																			className="mb-0 form-control "
																			validate={{
																				required:
																					{
																						value: true,
																					},
																			}}
																			id="validationDate"
																			value={
																				this
																					.props
																					.match
																					.params
																					.id ===
																				"0"
																					? moment(
																							new Date()
																					  ).format(
																							"YYYY-MM-DD"
																					  )
																					: this
																							.props
																							.mrRowData
																							.date
																			}
																			onChange={
																				this
																					.MRChangeHandeler
																			}
																		/>
																	</FormGroup>
																</Col>
																<Col
																	md="12"
																	className="p-1">
																	<FormGroup
																		style={{
																			marginBottom:
																				"0px",
																		}}>
																		<Label
																			htmlFor="OrderDescription"
																			className="col-form-label">
																			Description
																			:
																		</Label>

																		<AvField
																			name="description"
																			placeholder="Order Description"
																			type="textarea"
																			errorMessage="Enter Order Description "
																			className="form-control"
																			validate={{
																				required:
																					{
																						value: true,
																					},
																			}}
																			id="OrderDescription"
																			value={
																				this
																					.props
																					.match
																					.params
																					.id ===
																				"0"
																					? ""
																					: this
																							.props
																							.mrRowData
																							.description
																			}
																			onChange={
																				this
																					.MRChangeHandeler
																			}
																		/>
																	</FormGroup>
																</Col>
															</Row>
														</CardBody>
													</Card>
												</Col>
												<Col
													md={12}
													xl={
														this.state
															.showImageModal
															? 5
															: 8
													}>
													<Card className="p-1">
														<CardBody className="pt-1">
															<Row>
																<Col md={6}>
																	<h3 className="card-title-15 pt-2">
																		Request
																		Items
																		List
																	</h3>
																</Col>
																<Col md={6}>
																	<div className="float-right">
																		<Button
																			type="reset"
																			color="primary"
																			className="waves-effect waves-light ml-2 mr-2 d-inline-block"
																			onClick={() => {
																				this.props.getAllProducts(
																					{
																						...this
																							.props
																							.params,
																						page: 1,
																					},
																					true
																				);
																				this.props.model_open();
																			}}>
																			<i className="mdi mdi-plus-circle-outline mr-2"></i>
																			Add
																			New
																			Item
																		</Button>
																	</div>
																</Col>
															</Row>
															<Row>
																<Col
																	md={12}
																	className="m-2">
																	<div
																		className="table-responsive "
																		style={{
																			zIndex: "1",
																		}}>
																		<Table
																			striped
																			bordered
																			hover
																			className="table-centered ">
																			<thead className="bg-light text-center">
																				<tr>
																					<th className="nowrap ">
																						Item
																						Images
																					</th>
																					<th
																						style={{
																							minWidth:
																								"220px",
																						}}>
																						Item
																						Name
																					</th>
																					<th
																						style={{
																							minWidth:
																								"240px",
																						}}>
																						Quantity
																					</th>
																					<th
																						style={{
																							minWidth:
																								"120px",
																						}}>
																						Approved
																						Qty
																					</th>
																					<th className="nowrap">
																						Action
																					</th>
																				</tr>
																			</thead>
																			<tbody className="">
																				{this
																					.props
																					.selectedItems
																					.length !==
																				0 ? (
																					<>
																						{this.props.selectedItems
																							?.filter(
																								(
																									p
																								) =>
																									!p.dodelete
																							)
																							.map(
																								(
																									item,
																									key
																								) => (
																									<tr
																										key={
																											key
																										}>
																										<td className="text-center">
																											<img
																												src={
																													// item.product?.image ==
																													// null
																													//   ? DefaultImg
																													//   : item.product?.image
																													item
																														?.mritemimages?.[0]
																														?.image
																														? item
																																.mritemimages[0]
																																.image
																														: DefaultImg
																												}
																												alt="product-img"
																												title="product-img"
																												className="avatar-sm"
																											/>
																										</td>
																										<td
																											style={{
																												width: "220px",
																											}}>
																											<h5 className="font-size-14">
																												<Link
																													to="#"
																													onClick={
																														this
																															.tog_static
																													}
																													className="text-dark">
																													{
																														item
																															.product
																															?.name
																													}
																												</Link>
																											</h5>
																											<p className="mb-0">
																												Make
																												:
																												<span className="font-weight-medium">
																													{
																														item.make
																													}
																												</span>
																												<br />
																												Desc
																												:
																												<span className="font-weight-medium">
																													{
																														item.description
																													}
																												</span>
																												<br />
																												Item
																												Info
																												:
																												<span className="font-weight-medium">
																													{
																														item?.item_info
																													}
																												</span>
																											</p>
																										</td>
																										<td
																											// className="nowrap"
																											style={{
																												width: "220px",
																											}}>
																											<FormGroup
																												row
																												className="mb-0">
																												<Col
																													xs={
																														4
																													}
																													sm={
																														4
																													}
																													md={
																														4
																													}
																													lg={
																														4
																													}
																													xl={
																														4
																													}>
																													<Label
																														htmlFor="Qty"
																														className="col-form-label float-left">
																														Qty
																														:
																													</Label>
																												</Col>
																												<Col
																													xs={
																														8
																													}
																													sm={
																														8
																													}
																													md={
																														8
																													}
																													lg={
																														8
																													}
																													xl={
																														8
																													}>
																													<AvField
																														placeholder="Quantity"
																														className=" pr-0form-control"
																														min={
																															0
																														}
																														// max={100}
																														type="number"
																														// step="1"
																														id="qty"
																														name={
																															"qty" +
																															key
																														}
																														value={
																															item.qty
																														}
																														validate={{
																															required:
																																{
																																	value: true,
																																	errorMessage:
																																		"Please enter Qty",
																																},
																															pattern:
																																{
																																	value: "^[0-9]{1,18}([.-]?)[0-9]{0,3}$",
																																	errorMessage:
																																		"Qty can compose numbers and 3 decimals ",
																																},
																														}}
																														onChange={(
																															e
																														) =>
																															this.SItemChangeHandeler(
																																e,
																																item
																															)
																														}
																													/>
																												</Col>
																											</FormGroup>
																											<FormGroup
																												row
																												className="mb-0">
																												<Col
																													xs={
																														4
																													}
																													sm={
																														4
																													}
																													md={
																														4
																													}
																													lg={
																														4
																													}
																													xl={
																														4
																													}>
																													<Label
																														htmlFor="Units"
																														className="col-form-label float-left">
																														Units
																														:
																													</Label>
																												</Col>
																												<Col
																													xs={
																														8
																													}
																													sm={
																														8
																													}
																													md={
																														8
																													}
																													lg={
																														8
																													}
																													xl={
																														8
																													}>
																													<Select
																														id="units_select"
																														name="units_select"
																														required="required"
																														options={item?.product?.units?.map(
																															(
																																i
																															) => ({
																																label: i.name,
																																value: i.id,
																															})
																														)}
																														value={{
																															label: item
																																?.unit
																																?.name,
																															value: item
																																?.unit
																																?.id,
																														}}
																														onChange={(
																															e
																														) => {
																															this.props.SISelecteChangeValue(
																																{
																																	key: "unitsLabel",
																																	label: e.label,
																																	key2: "unit_id",
																																	value: e.value,
																																	item,
																																}
																															);
																														}}
																													/>
																												</Col>
																											</FormGroup>
																										</td>
																										<td className="text-center">
																											{
																												item.qty
																											}{" "}
																											{
																												item
																													.unit
																													?.name
																											}
																										</td>
																										<td className="nowrap text-center">
																											<Link
																												to="#"
																												onClick={() =>
																													this.removeCartItem(
																														item
																													)
																												}
																												className="action-icon text-danger bg-light ">
																												<i className="mdi mdi-trash-can font-size-18"></i>
																											</Link>
																										</td>
																									</tr>
																								)
																							)}
																					</>
																				) : (
																					<td
																						colSpan={
																							5
																						}
																						className="text-center ">
																						<span className="text-danger">
																							Please
																							Select
																							Items
																						</span>
																					</td>
																				)}
																			</tbody>
																		</Table>
																	</div>
																</Col>
															</Row>
														</CardBody>
													</Card>
												</Col>
												{this.state.showImageModal &&
													this.state
														.selectedOrderLocation
														?.image && (
														<Col md={12} xl={3}>
															<Card className="p-1">
																<CardHeader>
																	<h5>
																		Order
																		Location
																		Document:{" "}
																		
																	</h5>
																	<Button
																		color="secondary"
																		size="sm"
																		className="float-right"
																		onClick={() =>
																			this.setState(
																				{
																					showImageModal: false,
																				}
																			)
																		}>
																		Close
																	</Button>
																</CardHeader>
																<CardBody className="p-0">
																	{this.state.selectedOrderLocation.image.includes(
																		".pdf"
																	) ? (
																		<PdfViewer
																			url={
																				this
																					.state
																					.selectedOrderLocation
																					.image
																			}
																		/>
																	) : (
																		<img
																			src={
																				this
																					.state
																					.selectedOrderLocation
																					.image
																			}
																			alt="Order Location"
																			style={{
																				maxWidth:
																					"100%",
																				height: "auto",
																			}}
																		/>
																	)}
																</CardBody>
															</Card>
														</Col>
													)}
											</Row>
											<CardFooter className="bg-transparent pt-0">
												<div className="float-right">
													<AvField
														className="form-control"
														defaultValue={params.id}
														type="hidden"
														id="id"
														name="id"
													/>
													<Link to="/mrdashboard1">
														<Button
															type="reset"
															color="light"
															className="waves-effect waves-light mr-2">
															Cancel
														</Button>
													</Link>
													<Button
														type="submit"
														color="primary"
														className="waves-effect waves-light">
														Submit
													</Button>
												</div>
											</CardFooter>
										</CardBody>
									</Card>
								</Col>
							</Row>
						</AvForm>
					</Container>
				</div>
			</React.Fragment>
		);
	}
}

const mapStatetoProps = (state) => {
	const { userData } = state.userProfile;

	const {
		deparmentslist,
		locationslist,
		sublocationslist,
		userDeparment,
		suborderlocationslist,
	} = state.Mini;
	const {
		rowdata,
		mrRowData,
		model,
		selectedItems,
		reqrowdata,
		loading,
		MRItemImage,
	} = state.Materialrequest;
	return {
		userData,
		locationslist,
		sublocationslist,
		userDeparment,
		deparmentslist,
		rowdata,
		mrRowData,
		model,
		selectedItems,
		reqrowdata,
		loading,
		MRItemImage,
		suborderlocationslist,
	};
};

export default connect(mapStatetoProps, {
	clearData,
	getMiniLocations,
	getMiniSubLocations,
	getMiniDepartment,
	getUserDepartment,
	getMiniBasicUnits,
	InputChangeValue,
	SelecteChangeValue,
	MRInputChangeValue,
	MRSelecteChangeValue,
	SIInputChangeValue,
	SISelecteChangeValue,
	getAllProducts,
	SelectedProducts,
	removeSelectProducts,
	model_open,
	model_close,
	UpdateMRImage,
	addMaterialRequest,
	getReqestRowDetails,
	getMiniSubOrderLocations,
})(NewMaterialRequest);
